<!-- 查看询单弹框 -->
<template>
    <el-dialog custom-class="el-dialogOrderChangePopup" center append-to-body title="询单详情" :visible.sync="dialogVisible"
        width="55%">
        <inquiryInfoCard @update="update" v-if="dialogVisible" ref="inquiryInfoCard" :allDatas="allDatas">
        </inquiryInfoCard>
    </el-dialog>
</template>
<script>
import inquiryInfoCard from './inquiryDetailsPopupChild/inquiryInfoCard.vue';
import { OrderMinxin } from '../sonOrderMinxin'
export default {
    mixins: [OrderMinxin],
    props: {
        //这条数据的全部数据
        allDatas: {
            type: Object,
            default: {}
        },
    },
    components: {
        inquiryInfoCard
    },
    data() {
        return {
            dialogVisible: false
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick() {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.inquiryInfoCard.projectInquiryList()
            })
        },
        update() {
            this.dialogVisible = false
            // this.$refs.inquiryInfoCard.projectInquiryList()
        }
    },
    created() {

    },
    beforeDestroy() {
        this.$Bus.$off("PAY_SUCCESS");
    },
    mounted() {
        this.$Bus.$on("PAY_SUCCESS", (data) => {
            this.dialogVisible = false
        });
    }
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialogOrderChangePopup {
    margin-top: 10vh !important;
}
</style>